
  document.addEventListener('DOMContentLoaded', function() {
    // Find all sliders on the page
    const sliderContainers = document.querySelectorAll('.custom-img-slider__container');
    
    sliderContainers.forEach(container => {
      const slider = container.querySelector('.slider');
      const prevButton = container.querySelector('.custom-nav-button--prev');
      const nextButton = container.querySelector('.custom-nav-button--next');
      
      if (!slider || !prevButton || !nextButton) return;
      
      const slides = slider.querySelectorAll('.slider__slide');
      if (slides.length === 0) return;
      
      // Pull settings from data attributes
      const gap = Number(slider.dataset.gap || container.dataset.gap || 20);
      const autoplayEnabled = (slider.dataset.autoplay === 'true');
      const autoplaySpeed = Number(slider.dataset.autoplaySpeed || 4000);
      const infinite = (slider.dataset.infinite === 'true');

      // Calculate scroll amount based on slide width + gap
      function getScrollAmount() {
        if (slides.length === 0) return 0;
        return slides[0].offsetWidth + gap;
      }
      
      // Update button visibility
      function updateButtonVisibility() {
        if (infinite) {
          prevButton.disabled = false;
          prevButton.style.opacity = '';
          nextButton.disabled = false;
          nextButton.style.opacity = '';
          return;
        }

        const isAtStart = slider.scrollLeft <= 10;
        const isAtEnd = (slider.scrollLeft + slider.clientWidth) >= (slider.scrollWidth - 10);
        
        prevButton.disabled = isAtStart;
        prevButton.style.opacity = isAtStart ? '0.5' : '';
        
        nextButton.disabled = isAtEnd;
        nextButton.style.opacity = isAtEnd ? '0.5' : '';
      }
      
      // Initialize button visibility
      updateButtonVisibility();
      
      // Button click handlers
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        slider.scrollBy({
          left: -getScrollAmount(),
          behavior: 'smooth'
        });
        setTimeout(updateButtonVisibility, 300);
      });
      
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        slider.scrollBy({
          left: getScrollAmount(),
          behavior: 'smooth'
        });
        setTimeout(updateButtonVisibility, 300);
      });

      // Autoplay handling
      let autoplayTimer;

      function startAutoplay() {
        if (!autoplayEnabled || slides.length === 0) return;
        stopAutoplay();
        autoplayTimer = setInterval(() => {
          const amount = getScrollAmount();
          const maxScroll = slider.scrollWidth - slider.clientWidth;
          const nextLeft = slider.scrollLeft + amount;

          if (nextLeft >= maxScroll - 2) {
            if (infinite) {
              slider.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
              stopAutoplay();
            }
          } else {
            slider.scrollBy({ left: amount, behavior: 'smooth' });
          }
          setTimeout(updateButtonVisibility, 300);
        }, Math.max(autoplaySpeed, 500));
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }
      
      // Mouse drag scrolling
      let isDown = false;
      let startX;
      let scrollLeft;
      
      slider.addEventListener('mousedown', function(e) {
        isDown = true;
        slider.classList.add('grabbing');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        e.preventDefault();
      });
      
      slider.addEventListener('mouseleave', function() {
        isDown = false;
        slider.classList.remove('grabbing');
      });
      
      slider.addEventListener('mouseup', function() {
        isDown = false;
        slider.classList.remove('grabbing');
        updateButtonVisibility();
      });
      
      slider.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // Scroll speed multiplier
        slider.scrollLeft = scrollLeft - walk;
      });
      
      // Touch events for mobile
      slider.addEventListener('touchstart', function(e) {
        // Store initial touch position
        startX = e.touches[0].pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      }, { passive: true });
      
      slider.addEventListener('touchmove', function(e) {
        if (e.touches.length > 1) return; // Ignore multi-touch
        const x = e.touches[0].pageX - slider.offsetLeft;
        const walk = (x - startX) * 1.5;
        slider.scrollLeft = scrollLeft - walk;
      }, { passive: true });
      
      // Update button visibility on scroll
      slider.addEventListener('scroll', updateButtonVisibility);

      // Pause autoplay on user interaction
      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);
      slider.addEventListener('touchstart', stopAutoplay, { passive: true });
      slider.addEventListener('touchend', startAutoplay, { passive: true });
      
      // Update on window resize
      window.addEventListener('resize', function() {
        updateButtonVisibility();
      });

      // Kick off autoplay if enabled
      startAutoplay();
    });
  });
